import React from "react";
import { Badge, Image, Tooltip } from "antd";
import historyImg from "../../../assets/newIcons/EMR history.svg";
import iaImg from "../../../assets/newIcons/Initial Assessment.svg";
import activeIa from "../../../assets/newIcons/Initial Assessment Active.svg";
import activeHistory from "../../../assets/newIcons/EMR history Active.svg";
import physioCareImg from "../../../assets/newIcons/Physio Care.svg";
import physioCareActiveImg from "../../../assets/newIcons/Physio Care Active.svg";
import progressImg from "../../../assets/newIcons/Progress Notes.svg";
import activeProgressImg from "../../../assets/newIcons/Progress Notes Active.svg";
import gallery from "../../../assets/newIcons/gallery 1.svg";
import galleryActive from "../../../assets/newIcons/gallery 1 Active.svg";
import packagesImg from "../../../assets/newIcons/PAckage.svg";
import packagesActiveImg from "../../../assets/newIcons/PAckage Active.svg";
import progressScaleIcon from "../../../assets/newIcons/Progress Scale.svg";
import progressScaleActiveIcon from "../../../assets/newIcons/Progress Scale Active.svg";
import SummaryIcon from "../../../assets/newIcons/SUmmary.svg";
import SummaryIconActive from "../../../assets/newIcons/SUmmary Active.svg";
import steth from "../../../assets/newIcons/stethoscope.svg";
import stethActive from "../../../assets/newIcons/stethoscope  Active.svg";
import { isPhysiotherapistRole } from "./opHelpers";

const OP_TAB_TITLES = {
  history: "EMR History",
  ia: "Initial Assessment",
  review: "Review",
  "physio-care": "Physio Care",
  progress_scale: "Progress Scale",
  gallery: "Gallery",
  packages: "Package",
  progress_monitoring: "Progress Notes",
  summary: "Summary",
};

const CLINICAL_FORM_PREFIX = "clinical-form-";

const PHYSIO_ONLY_TAB_KEYS = new Set([
  "history",
  "ia",
  "physio-care",
  "progress_scale",
]);

export const getuserRoleTabs = (
  ROLE,
  tab,
  token,
  pastEmrCount = 0,
  options = {}
) => {
  if (!token) return [];

  const { compactIcons = false, hideTooltips = false } = options;
  const activeStyles = {
    height: compactIcons ? "42px" : "50px",
    width: "auto",
    background: token.colorPrimary,
    padding: compactIcons ? "8px" : "10px",
    borderRadius: "6px",
    display: "block",
    marginBottom: compactIcons ? "0" : "8px",
  };

  const styles = {
    height: compactIcons ? "42px" : "50px",
    width: "auto",
    background: "#fff",
    padding: compactIcons ? "8px" : "10px",
    borderRadius: "6px",
    border: "1px solid #D9D9D9",
    display: "block",
    marginBottom: compactIcons ? "0" : "8px",
  };

  const menuImages = (icon, styleObj, title) => {
    const iconNode = (
      <Image
        src={icon}
        preview={false}
        style={styleObj}
        alt={title}
        key={title}
      />
    );
    if (hideTooltips) return iconNode;
    return (
      <Tooltip title={title} key={title} trigger={["hover"]} mouseEnterDelay={0.15}>
        {iconNode}
      </Tooltip>
    );
  };

  const withTabTitle = (key, label) => ({
    label,
    key,
    tabTitle: OP_TAB_TITLES[key] || key,
    title: hideTooltips ? OP_TAB_TITLES[key] || key : null,
  });

  const allTabs = [
    withTabTitle(
      "history",
      (
        <Badge
          className="op-history-icon-badge"
          count={pastEmrCount}
          size="small"
          offset={[0, 0]}
          showZero={false}
        >
          {tab === "history"
            ? menuImages(activeHistory, activeStyles, "EMR History")
            : menuImages(historyImg, styles, "EMR History")}
        </Badge>
      )
    ),
    withTabTitle(
      "ia",
      tab === "ia"
        ? menuImages(activeIa, activeStyles, "Initial Assessment")
        : menuImages(iaImg, styles, "Initial Assessment")
    ),
    withTabTitle(
      "physio-care",
      tab === "physio-care"
        ? menuImages(physioCareActiveImg, activeStyles, "Physio Care")
        : menuImages(physioCareImg, styles, "Physio Care")
    ),
    withTabTitle(
      "progress_scale",
      tab === "progress_scale"
        ? menuImages(progressScaleActiveIcon, activeStyles, "Progress Scale")
        : menuImages(progressScaleIcon, styles, "Progress Scale")
    ),
    withTabTitle(
      "gallery",
      tab === "gallery"
        ? menuImages(galleryActive, activeStyles, "Gallery")
        : menuImages(gallery, styles, "Gallery")
    ),
    withTabTitle(
      "packages",
      tab === "packages"
        ? menuImages(packagesActiveImg, activeStyles, "Package")
        : menuImages(packagesImg, styles, "Package")
    ),
    withTabTitle(
      "progress_monitoring",
      tab === "progress_monitoring"
        ? menuImages(activeProgressImg, activeStyles, "Progress Notes")
        : menuImages(progressImg, styles, "Progress Notes")
    ),
    withTabTitle(
      "summary",
      tab === "summary"
        ? menuImages(SummaryIconActive, activeStyles, "Summary")
        : menuImages(SummaryIcon, styles, "Summary")
    ),
  ];

  const baseTabs = isPhysiotherapistRole(ROLE)
    ? allTabs
    : allTabs.filter((item) => !PHYSIO_ONLY_TAB_KEYS.has(item.key));

  const { clinicalForms = {} } = options;
  const { leading, trailing } = buildDynamicTabs({
    clinicalForms,
    tab,
    menuImages,
    styles,
    activeStyles,
    withTabTitle,
    existingKeys: new Set(baseTabs.map((t) => t.key)),
  });

  return [...leading, ...baseTabs, ...trailing];
};

const buildDynamicTabs = ({
  clinicalForms,
  tab,
  menuImages,
  styles,
  activeStyles,
  withTabTitle,
  existingKeys,
}) => {
  const { iaForm, reviewForm, otherForms = [] } = clinicalForms;
  const leading = [];
  const trailing = [];

  if (iaForm && !existingKeys.has("ia")) {
    leading.push(
      withTabTitle(
        "ia",
        tab === "ia"
          ? menuImages(activeIa, activeStyles, "Initial Assessment")
          : menuImages(iaImg, styles, "Initial Assessment")
      )
    );
  }

  if (reviewForm && !existingKeys.has("review")) {
    leading.push(
      withTabTitle(
        "review",
        tab === "review"
          ? menuImages(stethActive, activeStyles, "Review")
          : menuImages(steth, styles, "Review")
      )
    );
  }

  const otherChildren = otherForms
    .filter((f) => !existingKeys.has(`${CLINICAL_FORM_PREFIX}${f.id}`))
    .map((f) => ({
      key: `${CLINICAL_FORM_PREFIX}${f.id}`,
      label: f.name || "Form",
    }));

  if (otherChildren.length > 0 && !existingKeys.has("forms")) {
    trailing.push({
      key: "forms",
      label: "Forms",
      tabTitle: "Forms",
      children: otherChildren,
    });
  }

  return { leading, trailing };
};
